module.exports = __webpack_public_path__ + "img/fee.0d01ed8b.svg";